import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/app-update/IosAppVersionGate.tsx");
